import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=25af27f9"
import script from "./InviteModal.vue?vue&type=script&lang=ts"
export * from "./InviteModal.vue?vue&type=script&lang=ts"
import style0 from "./InviteModal.vue?vue&type=style&index=0&id=25af27f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports